require('./bootstrap');

/**
 * Initialize all Select2 selects when the DOM is ready.
 *
 * @returns void
 */
window.initSelect2 = function () {
    $('.select2').select2({theme: 'bootstrap4'});
}

document.addEventListener('select2:init', function () {
    initSelect2();
})

document.addEventListener('bootstrap-dropdown:init', function () {
    $('[data-toggle="dropdown"]').dropdown();
})

import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

window.Chart = Chart;
window.ChartDataLabels = ChartDataLabels;
